import { UserService } from './../service/user.service';
import { Injectable } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from '../service/base.service';
import { AuthService } from '../service/auth.service';
import { AlertService } from '../service/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { UserProfileService } from './../service/userProfile.service';

@Injectable()
export class UserResolver implements Resolve<ApiObjectData> {
  constructor(
    private service: UserService,
    private baseService: BaseService
  ) { }
  resolve(route: ActivatedRouteSnapshot): Observable<ApiObjectData> {
    return this.baseService.resolveGet(this.service, route, '/page/users');
  }
}


@Injectable({
  providedIn: 'root'
})
export class UserProfileResolver implements Resolve<ApiObjectData> {
  constructor(
    private service: UserProfileService,
    private baseService: BaseService,
  ) { }
  resolve(route: ActivatedRouteSnapshot): Observable<ApiObjectData> {
    // return this.requestService.getRequest(route.params.id)
    return this.baseService.resolveOperation(this.service.getforProfile(route.params.id));
  }
}


@Injectable({
  providedIn: 'root'
})
export class UsersResolver implements Resolve<ApiObjectData> {
  constructor(
    private service: UserService,
    private baseService: BaseService
  ) { }
  resolve(): Observable<ApiObjectData> {
    return this.baseService.resolveGets(this.service);
  }
}

@Injectable({
  providedIn: 'root'
})
export class CurrantUserResolver implements Resolve<ApiObjectData> {
  constructor(
    private service: UserService,
    private baseService: BaseService,
    private alertService: AlertService,
    private router: Router,
    private translate: TranslateService
  ) { }
  resolve(): Observable<ApiObjectData> {
    return this.baseService.resolveOperation(this.service.getCurrant()).pipe(
      catchError(error => {
        if (error.statusText === 'Unauthorized' || error.status === 401) {
          this.alertService.error(this.translate.instant('Loginerror'));
          this.router.navigate(['']);
          return of(null);
        }

      })
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class UserDataResolver implements Resolve<ApiObjectData> {
  constructor(
    private service: UserService,
    private baseService: BaseService,
    private authService: AuthService,
    private router: Router,
    private alertService: AlertService,
    private translate: TranslateService
  ) { }
  resolve(): Observable<ApiObjectData> {
    return this.service.userData(this.authService.user.id).pipe(
      catchError(error => {
        if (error.statusText === 'Unauthorized' || error.status === 401) {
          this.alertService.error(this.translate.instant('Loginerror'));
          this.router.navigate(['']);
          return of(null);
        }
        else {
          this.alertService.error(this.translate.instant('toastrMsg.unexpectedError'));
          this.router.navigate(['']);
          return of(null);
        }

      })
    );

  }
}
